import React from "react";

// Reusable section page header with overline + title + subtitle
export const PageHeader = ({ overline, title, subtitle }) => (
  <section className="relative ivory-gold-bg border-b border-gold/15 overflow-hidden">
    <div className="god-rays absolute inset-0" />
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28 text-center">
      {overline && (
        <p className="text-xs uppercase tracking-[0.3em] text-gold font-semibold mb-4">{overline}</p>
      )}
      <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-light text-brown-black tracking-tight" data-testid="page-title">
        {title}
      </h1>
      {subtitle && (
        <p className="mt-5 max-w-2xl mx-auto text-base md:text-lg text-brown-black/70 leading-relaxed">{subtitle}</p>
      )}
      <div className="gold-line w-24 mx-auto mt-8" />
    </div>
  </section>
);

export default PageHeader;
